import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import Icon from '../../icon'

import Button from '../../button'

import DownloadIcon from '../../icon/download.svg'

const Download = ({ resource, ...attrs }) => {
  const resourceURL = get(
    resource,
    'document.meta.downloadUrl',
    null
  ) || get(
    resource,
    'multimedia.file',
    null
  )

  attrs.background = true
  attrs.href = resourceURL
  attrs.target = '_blank'
  attrs.rel = 'noopener noreferrer'

  return resourceURL
    ? <Button
      {...attrs}>
      Descargar{' '}
      <Icon
        svg={DownloadIcon}
        width="24"
        height="24"
        className="ml-2"
      />
    </Button>
    : null
}

Download.propTypes = {
  resource: PropTypes.object
}

export default Download
